import ClientsFilter from "./Filter/ClientsFilter";

export default function FilterJobSize(){
  return(
    <div className='filters-jobs'>
      <ClientsFilter/>
    </div>
  )
}
